export const downloadPkpass = (data, fileName) => {
  const link = document.createElement('a');
  const appleWalletPass = new Blob([data], { type: 'application/vnd.apple.pkpass' });
  const objectUrl = URL.createObjectURL(appleWalletPass);

  link.href = objectUrl;
  link.download = `${fileName}.pkpass`;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(objectUrl);
};



export default {
  downloadPkpass
};
